import { create } from 'zustand';

type DashboardRefreshStore = {
  revision: number;
  requestRefresh: () => void;
};

/** Allows mutations outside the Home page to invalidate its dashboard read model. */
export const useDashboardRefreshStore = create<DashboardRefreshStore>(
  (set) => ({
    revision: 0,
    requestRefresh: () => set((state) => ({ revision: state.revision + 1 }))
  })
);
